/**
 * Main JavaScript file
 */

import './video-trigger.js';

document.addEventListener('DOMContentLoaded', function() {
    console.log('WS Theme loaded');

    // Theme toggle disabled: force dark mode handled by static data-theme on <html>

    // Global throttled Locomotive update helper
    (function(){
        try {
            var scheduled = false;
            function locoUpdate(){
                if (scheduled) return;
                scheduled = true;
                requestAnimationFrame(function(){
                    scheduled = false;
                    try {
                        if (window.wsScroll && typeof window.wsScroll.update === 'function') {
                            window.wsScroll.update();
                        }
                    } catch (e) {}
                });
            }
            window.wsLocoUpdate = locoUpdate;
            // Optional: listen to custom mutation events from widgets
            window.addEventListener('ws:swiper-mutated', locoUpdate);
        } catch (e) {}
    })();
    // Offcanvas burger menu (accordion-style height animation pushing header via CSS var)
    (function(){
        var burger = document.querySelector('.burger');
        var burgerLabel = document.querySelector('.burger__label');
        var offcanvas = document.getElementById('offcanvas-menu');
        var header = document.getElementById('masthead');
        if (!burger || !offcanvas || !header) return;

        var panel = offcanvas.querySelector('.offcanvas__panel');

        function measurePanelHeight(){
            if (!panel) return 0;
            // Ensure content height is measured
            var prevTransition = panel.style.transition;
            var prevHeight = panel.style.height;
            panel.style.transition = 'none';
            panel.style.height = 'auto';
            var h = panel.scrollHeight;
            // restore
            panel.style.height = prevHeight;
            // force reflow to avoid transition glitch
            void panel.offsetHeight;
            panel.style.transition = prevTransition;
            return h;
        }

        function openMenu(){
            var targetHeight = measurePanelHeight();
            // transition from 0 -> target
            panel.style.height = '0px';
            offcanvas.setAttribute('aria-hidden', 'false');
            // next frame set to target height to animate
            requestAnimationFrame(function(){
                panel.style.height = targetHeight + 'px';
            });
            // after transition, lock to auto for responsiveness
            var onEnd = function(e){
                if (e.propertyName !== 'height') return;
                panel.style.height = 'auto';
                panel.removeEventListener('transitionend', onEnd);
            };
            panel.addEventListener('transitionend', onEnd);
            burger.classList.add('is-active');
            burger.setAttribute('aria-expanded', 'true');
            if (burgerLabel) {
                try { burgerLabel.setAttribute('aria-expanded', 'true'); } catch (e) {}
            }
            header.classList.add('is-menu-open');
        }
        function closeMenu(){
            // measure current auto height and animate to 0
            var currentHeight = measurePanelHeight();
            panel.style.height = currentHeight + 'px';
            // force reflow then collapse
            void panel.offsetHeight;
            panel.style.height = '0px';
            var onEnd = function(e){
                if (e.propertyName !== 'height') return;
                offcanvas.setAttribute('aria-hidden', 'true');
                panel.removeEventListener('transitionend', onEnd);
            };
            panel.addEventListener('transitionend', onEnd);
            burger.classList.remove('is-active');
            burger.setAttribute('aria-expanded', 'false');
            if (burgerLabel) {
                try { burgerLabel.setAttribute('aria-expanded', 'false'); } catch (e) {}
            }
            header.classList.remove('is-menu-open');
        }
        function toggleMenu(){
            var hidden = offcanvas.getAttribute('aria-hidden') !== 'false';
            hidden ? openMenu() : closeMenu();
        }

        burger.addEventListener('click', toggleMenu);
        if (burgerLabel) {
            try {
                burgerLabel.setAttribute('role', 'button');
                burgerLabel.setAttribute('tabindex', '0');
                burgerLabel.setAttribute('aria-controls', 'offcanvas-menu');
                burgerLabel.setAttribute('aria-expanded', 'false');
            } catch (e) {}
            burgerLabel.addEventListener('click', toggleMenu);
            burgerLabel.addEventListener('keydown', function(e){
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleMenu();
                }
            });
        }

        // Disable backdrop closing behavior (accordion style)
        offcanvas.addEventListener('click', function(e){
            var target = e.target;
            if (!target) return;
            if (target.hasAttribute('data-offcanvas-close')) {
                // no-op now
            }
        });

        document.addEventListener('keydown', function(e){
            if (e.key === 'Escape') closeMenu();
        });

        // Recompute on resize when open
        var resizeTimer;
        window.addEventListener('resize', function(){
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function(){
                if (offcanvas.getAttribute('aria-hidden') === 'false') {
                    // keep auto height responsive
                    panel.style.height = 'auto';
                }
            }, 150);
        });
    })();


    // Headroom integration
    (function(){
        try {
            var header = document.querySelector('#masthead');
            if (!header) return;

            // When Locomotive is absent, use native Headroom if available
            if (window.Headroom && !window.LocomotiveScroll) {
                var headroom = new window.Headroom(header, {
                    tolerance: { up: 5, down: 0 },
                    offset: 80,
                    classes: {
                        initial: 'headroom',
                        pinned: 'headroom--pinned',
                        unpinned: 'headroom--unpinned',
                        top: 'headroom--top',
                        notTop: 'headroom--not-top',
                        bottom: 'headroom--bottom',
                        notBottom: 'headroom--not-bottom'
                    }
                });
                headroom.init();
                return;
            }

            // When Locomotive is present, emulate Headroom using its scroll events
            var attached = false;
            function attachToScroll(scroll){
                if (!scroll || typeof scroll.on !== 'function' || attached) return;
                attached = true;
                var lastY = 0;
                var ticking = false;
                var toleranceUp = 5;
                var toleranceDown = 0;
                var offset = 80;
                header.classList.add('headroom');

                function setState(state){
                    if (state === 'pinned') {
                        header.classList.add('headroom--pinned');
                        header.classList.remove('headroom--unpinned');
                    } else if (state === 'unpinned') {
                        header.classList.add('headroom--unpinned');
                        header.classList.remove('headroom--pinned');
                    }
                }

                function onScroll(data){
                    if (ticking) return;
                    ticking = true;
                    requestAnimationFrame(function(){
                        var y = data && typeof data.scroll === 'object' ? (data.scroll.y || 0) : 0;
                        var delta = y - lastY;
                        var absDelta = Math.abs(delta);

                        // Top/bottom states
                        var atTop = y <= 0;
                        header.classList.toggle('headroom--top', atTop);
                        header.classList.toggle('headroom--not-top', !atTop);

                        if (y < offset) {
                            // Before offset, keep pinned
                            setState('pinned');
                        } else {
                            if (delta > 0 && absDelta > toleranceDown) {
                                // Scrolling down
                                setState('unpinned');
                            } else if (delta < 0 && absDelta > toleranceUp) {
                                // Scrolling up
                                setState('pinned');
                            }
                        }

                        lastY = y;
                        ticking = false;
                    });
                }

                // Initial state
                setState('pinned');
                scroll.on('scroll', onScroll);
            }

            if (window.wsScroll) attachToScroll(window.wsScroll);
            window.addEventListener('ws:locomotive-ready', function(e){
                var s = e && e.detail && e.detail.scroll;
                attachToScroll(s || window.wsScroll);
            }, { once: true });
        } catch (e) {}
    })();

    // Mobile menu toggle for primary navigation
    // Replaced by offcanvas burger menu

    // Language switcher: custom dropdown and navigate on click
    (function(){
        try {
            var wrapper = document.querySelector('.lang-switcher--dropdown');
            if (!wrapper) return;
            var btn = wrapper.querySelector('.lang-current');
            var list = wrapper.querySelector('.lang-options');
            if (!btn || !list) return;

            function toggle(){
                var open = wrapper.classList.contains('is-open');
                if (open) {
                    wrapper.classList.remove('is-open');
                    btn.setAttribute('aria-expanded', 'false');
                } else {
                    wrapper.classList.add('is-open');
                    btn.setAttribute('aria-expanded', 'true');
                }
            }

            btn.addEventListener('click', toggle);
            btn.addEventListener('keydown', function(e){
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggle();
                }
            });

            // Click outside to close
            document.addEventListener('click', function(e){
                if (!wrapper.contains(e.target)) {
                    if (wrapper.classList.contains('is-open')) toggle();
                }
            });
        } catch (e) {}
    })();

    function initModel3DSection(context) {
        var root = context || document;
        var els = root.querySelectorAll('.js-model3d-section__canvas');
        if (!els || !els.length) return;
        els.forEach(function(el){
            if (!el || el.dataset.model3dReady) return;
            el.dataset.model3dReady = '1';
            // Lazy import to avoid bundling heavy three.js into editor unnecessarily
            import(/* @vite-ignore */ './model3d-section.js').then(function(mod){
                if (mod && typeof mod.initModel3DSection === 'function') {
                    mod.initModel3DSection(el);
                }
            }).catch(function(){});
        });
    }

    try { window.wsInitModel3DSectionIn = initModel3DSection; } catch (e) {}
    // Ensure initialization runs even if the block view script fires earlier
    initModel3DSection(document);

    // Locomotive Scroll init
    (function(){
        try {
            var container = document.querySelector('[data-scroll-container]');
            if (!container || !window.LocomotiveScroll) return;

            var prefersReducedMotion = false;
            try {
                prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            } catch (e) {}
            var isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0));

            // Optionally mark sections to help Locomotive split
            // try {
            //     container.querySelectorAll('section').forEach(function(sec){
            //         if (!sec.hasAttribute('data-scroll-section')) sec.setAttribute('data-scroll-section', '');
            //     });
            // } catch (e) {}

            var useSmooth = !prefersReducedMotion && !isTouch;

            var scroll = new window.LocomotiveScroll({
                el: container,
                smooth: useSmooth,
                lerp: 0.1,
                smartphone: { smooth: false },
                tablet: { smooth: false }
            });

            try { window.wsScroll = scroll; } catch (e) {}
            try {
                window.dispatchEvent(new CustomEvent('ws:locomotive-ready', { detail: { scroll: scroll } }));
            } catch (e) {}

            // Update after images/fonts load
            window.addEventListener('load', function(){
                try { scroll.update(); } catch (e) {}
            });

            var resizeTimer;
            window.addEventListener('resize', function(){
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function(){
                    try { scroll.update(); } catch (e) {}
                }, 200);
            });
        } catch (e) {}
    })();
});